import {
    CAMPAIGN_CREATE_FAIL,
    CAMPAIGN_CREATE_REQUEST,
    CAMPAIGN_CREATE_RESET,
    CAMPAIGN_CREATE_SUCCESS,
    CAMPAIGN_LIST_FAIL,
    CAMPAIGN_LIST_REQUEST,
    CAMPAIGN_LIST_RESET,
    CAMPAIGN_LIST_SUCCESS,
    CAMPAIGN_DETAIL_REQUEST,
    CAMPAIGN_DETAIL_SUCCESS,
    CAMPAIGN_DETAIL_FAIL,
    CAMPAIGN_UPDATE_REQUEST,
    CAMPAIGN_UPDATE_SUCCESS,
    CAMPAIGN_UPDATE_FAIL,
    CAMPAIGN_UPDATE_DETAILS_RESET,
    CAMPAIGN_DELETE_REQUEST,
    CAMPAIGN_DELETE_SUCCESS,
    CAMPAIGN_DELETE_FAIL,
    CAMPAIGN_DELETE_RESET,
} from '../constants/campaignConstants';

export const campaignListReducer = (state = { campaignList: [] }, action) => {
    switch (action.type) {
        case CAMPAIGN_LIST_REQUEST:
            return { loading: true };
        case CAMPAIGN_LIST_SUCCESS:
            return {
                loading: false,
                campaignList: action.payload,
                success: true,
            };
        case CAMPAIGN_LIST_FAIL:
            return { loading: false, error: action.payload };
        case CAMPAIGN_LIST_RESET:
            return { loading: false, error: null, success: false };
        default:
            return state;
    }
};

export const campaignCreateReducer = (state = {}, action) => {
    switch (action.type) {
        case CAMPAIGN_CREATE_REQUEST:
            return { loading: true };
        case CAMPAIGN_CREATE_SUCCESS:
            return { loading: false, campaign: action.payload };
        case CAMPAIGN_CREATE_FAIL:
            return { loading: false, error: action.payload };
        case CAMPAIGN_CREATE_RESET:
            return { loading: false, error: null };
        default:
            return state;
    }
};

export const campaignDetailReducer = (state = { campaign: {} }, action) => {
    switch (action.type) {
        case CAMPAIGN_DETAIL_REQUEST:
            return { loading: true };
        case CAMPAIGN_DETAIL_SUCCESS:
            return { loading: false, campaign: action.payload };
        case CAMPAIGN_DETAIL_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};

export const campaignUpdateReducer = (state = { campaign: {} }, action) => {
    switch (action.type) {
        case CAMPAIGN_UPDATE_REQUEST:
            return { loading: true };
        case CAMPAIGN_UPDATE_SUCCESS:
            return {
                loading: false,
                success: true,
                campaign: action.payload,
            };
        case CAMPAIGN_UPDATE_FAIL:
            return { loading: false, error: action.payload };
        case CAMPAIGN_UPDATE_DETAILS_RESET:
            return { campaign: {} };
        default:
            return state;
    }
};

export const campaignDeleteReducer = (state = { success: false }, action) => {
    switch (action.type) {
        case CAMPAIGN_DELETE_REQUEST:
            return { loading: true, ...state };
        case CAMPAIGN_DELETE_SUCCESS:
            return { loading: false, success: true };
        case CAMPAIGN_DELETE_FAIL:
            return { loading: false, success: false, error: action.payload };
        case CAMPAIGN_DELETE_RESET:
            return { loading: false, success: false, error: null };
        default:
            return state;
    }
};
